import { stateProps } from "../types";

export const nextButtonProcess = (state: stateProps) => {
  if (state.step === 0) {
    return {
      ...state,
      step: 1,
    };
  } else if (state.step === 1) {
    const { isEmptyTitleField } = state;
    if (!isEmptyTitleField) {
      return {
        ...state,
        step: 2,
      };
    }
  } else if (state.step === 2) {
    const { isEmptyFirstName, isEmptyLastName } = state;
    if (!(isEmptyFirstName || isEmptyLastName)) {
      return {
        ...state,
        step: 3,
      };
    }
  } else if (state.step === 3) {
    const { isEmptyGenderField } = state;
    if (!isEmptyGenderField) {
      return {
        ...state,
        step: 4,
      };
    }
  } else if (state.step === 4) {
    const { isEmptyAndValidEmail } = state;
    if (!isEmptyAndValidEmail) {
      return {
        ...state,
        step: 5,
      };
    }
  } else if (state.step === 5) {
    const { isEmptyPhone } = state;
    if (!isEmptyPhone) {
      return {
        ...state,
        step: 6,
      };
    }
  } else if (state.step === 6) {
    const { isEmptyLanguagesField } = state;
    if (!isEmptyLanguagesField) {
      return {
        ...state,
        step: 7,
      };
    }
  } else if (state.step === 7) {
    const { isEmptyDegree } = state;
    if (!isEmptyDegree) {
      return {
        ...state,
        step: 8,
      };
    }
  } else if (state.step === 8) {
    const { isEmptyQualifications } = state;
    if (!isEmptyQualifications) {
      return {
        ...state,
        step: 9,
      };
    }
  } else if (state.step === 9) {
    const { isEmptyPrice } = state;
    if (!isEmptyPrice) {
      return {
        ...state,
        step: 10,
      };
    }
  } else if (state.step === 10) {
    const { isEmptyTimeSlotField } = state;
    if (!isEmptyTimeSlotField) {
      return {
        ...state,
        step: 11,
      };
    }
  } else if (state.step === 11) {
    const { isEmptyRegiNumber } = state;
    if (!isEmptyRegiNumber) {
      return {
        ...state,
        step: 12,
      };
    }
  } else if (state.step === 12) {
    const { isEmptySpeciality } = state;
    if (!isEmptySpeciality) {
      return {
        ...state,
        step: 13,
      };
    }
  } else if (state.step === 13) {
    const { isEmptyBoardCertifiedField } = state;
    if (!isEmptyBoardCertifiedField) {
      return {
        ...state,
        step: 14,
      };
    }
  } else if (state.step === 14) {
    const { isEmptyPractising } = state;
    if (!isEmptyPractising) {
      return {
        ...state,
        step: 15,
      };
    }
  } else if (state.step === 15) {
    const { isEmptyBankName } = state;
    if (!isEmptyBankName) {
      return {
        ...state,
        step: 16,
      };
    }
  } else if (state.step === 16) {
    const { isEmptyBranchName } = state;
    if (!isEmptyBranchName) {
      return {
        ...state,
        step: 17,
      };
    }
  } else if (state.step === 17) {
    const { isEmptyAcntHolder } = state;
    if (!isEmptyAcntHolder) {
      return {
        ...state,
        step: 18,
      };
    }
  } else if (state.step === 18) {
    const { isEmptyAcntNumber } = state;
    if (!isEmptyAcntNumber) {
      return {
        ...state,
        step: 19,
      };
    }
  } else if (state.step === 19) {
    const { isEmptySignatureImageField } = state;
    if (!isEmptySignatureImageField) {
      return {
        ...state,
        step: 20,
      };
    }
  } else if (state.step === 20) {
    const { isEmptyProfileImageField } = state;
    if (!isEmptyProfileImageField) {
      return {
        ...state,
        step: 21,
      };
    }
  } else if (state.step === 21) {
    const { isEmptyNicImageField } = state;
    if (!isEmptyNicImageField) {
      return {
        ...state,
        step: 22,
      };
    }
  } else if (state.step === 22) {
    const { isEmptySealImageField } = state;
    if (!isEmptySealImageField) {
      return {
        ...state,
        step: 23,
      };
    }
  } else if (state.step === 23) {
    const { isEmptySlmcCertificateImageField } = state;
    if (!isEmptySlmcCertificateImageField) {
      return {
        ...state,
        step: 24,
      };
    }
  } else if (state.step === 24) {
    const { isEmptySlmcIDImageField } = state;
    if (!isEmptySlmcIDImageField) {
      return {
        ...state,
        step: 25,
      };
    }
  } else if (state.step === 25) {
    const { isEmptyProofOfQualificationImageField } = state;
    if (!isEmptyProofOfQualificationImageField) {
      return {
        ...state,
        step: 26,
      };
    }
  } else if (state.step === 26) {
    const { isEmptyTermsAndConditionsField, termsAndConditions } = state;
    // Submit the Form Process
    if (!isEmptyTermsAndConditionsField && termsAndConditions === "I accept") {
      return {
        ...state,
        step: 27,
      };
    }
  }

  return state;
};
